module.exports = __webpack_public_path__ + "img/checked-black.8d4ad270.svg";